windowWithDevTools